"use client";

import React from "react";
import { store } from ".";
import { Provider } from "react-redux";

export default function StoreProvider({
  // Layouts must accept a children prop.
  // This will be populated with nested layouts or pages
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <Provider store={store}>
      <>{children}</>
    </Provider>
  );
}
